import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, ListItemButton, Chip, Box, Typography } from '@mui/material';
import environments from '../constants/environments.json';
import { getApiEnvironment as getApiEnv, setApiEnvironment as setApiEnv } from '../constants/api.constants';

interface EnvironmentSwitcherProps {
  open: boolean;
  onClose: () => void;
}

interface EnvironmentEntry {
  tag: string;
  name: string;
}

export const EnvironmentSwitcher: React.FC<EnvironmentSwitcherProps> = ({ open, onClose }) => {
  const [currentEnvironment, setCurrentEnvironment] = useState<string>(getApiEnv());

  const handleEnvironmentSelect = async (tag: string) => {
    setApiEnv(tag);
    setCurrentEnvironment(tag);
    window.location.reload();
  };

  const envEntries: EnvironmentEntry[] = Object.entries(environments).map(([tag, config]) => ({
    tag,
    name: config.displayName,
  }));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Switch Environment</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Select a backend environment. The page will reload after switching.
        </Typography>

        <List>
          {envEntries.map((env) => (
            <ListItem key={env.tag} disablePadding>
              <ListItemButton
                onClick={() => handleEnvironmentSelect(env.tag)}
                selected={currentEnvironment === env.tag}
              >
                <ListItemText
                  primary={
                    <Box display="flex" alignItems="center" gap={1}>
                      <span style={{ textTransform: 'capitalize' }}>{env.name}</span>
                      {currentEnvironment === env.tag && (
                        <Chip label="Current" size="small" color="primary" />
                      )}
                    </Box>
                  }
                  secondary={env.tag}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default EnvironmentSwitcher;
